import { render, staticRenderFns } from "./IbxAssessmentDescriptionModal.vue?vue&type=template&id=70cde372"
import script from "./IbxAssessmentDescriptionModal.vue?vue&type=script&lang=js"
export * from "./IbxAssessmentDescriptionModal.vue?vue&type=script&lang=js"
import style0 from "./IbxAssessmentDescriptionModal.vue?vue&type=style&index=0&id=70cde372&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports